@if (unsavedChangesService.isVisible()) {
  <elcia-dialog
    (onAction)="unsavedChangesService.answer(true)"
    (onClose)="unsavedChangesService.answer(false)"
    [actionIcon]="'right-arrow'"
    [actionLabel]="'action.leave-without-saving'"
    [size]="'x-small'"
    [title]="'app.unsaved-changes' | translate">
    <div class="font-medium">{{ 'app.unsaved-changes-warning' | translate }}</div>
  </elcia-dialog>
}
